// QR di struk (tautan ulasan Google): matriks modul dibuat langsung dari teks (sinkron, tanpa memuat gambar), lalu
// dipakai untuk tampilan layar/cetak browser (SVG) dan printer thermal ESC/POS (raster 1-bit, perintah GS v 0).
import QRCode from 'qrcode';

const MARGIN = 3; // zona tenang (modul) di sekeliling QR

/** Matriks modul QR: { ukuran, gelap(x, y) } (true = modul hitam). */
export const matriksQr = (teks) => {
  const { modules } = QRCode.create(String(teks), { errorCorrectionLevel: 'M' });
  const ukuran = modules.size;
  return { ukuran, gelap: (x, y) => x >= 0 && y >= 0 && x < ukuran && y < ukuran && modules.data[y * ukuran + x] === 1 };
};

/** QR sebagai teks SVG (viewBox dalam modul, termasuk zona tenang); skala mengikuti ukuran elemen. */
export const svgQr = (teks) => {
  const { ukuran, gelap } = matriksQr(teks);
  const total = ukuran + MARGIN * 2;
  let d = '';
  for (let y = 0; y < ukuran; y += 1) {
    for (let x = 0; x < ukuran; x += 1) if (gelap(x, y)) d += `M${x + MARGIN} ${y + MARGIN}h1v1h-1z`;
  }
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${total} ${total}" shape-rendering="crispEdges"><rect width="${total}" height="${total}" fill="#fff"/><path d="${d}" fill="#000"/></svg>`;
};

/**
 * QR sebagai bitmap monokrom 1-bit untuk ESC/POS GS v 0: tiap modul = skala x skala titik (skala bulat, minimal 3 titik
 * supaya terbaca pemindai), lebar dibulatkan ke kelipatan 8 titik. targetTitik = lebar QR yang diinginkan, maksTitik = lebar kertas.
 * @returns {{widthBytes:number, heightDots:number, bytes:Uint8Array}}
 */
export const rasterQr = (teks, { targetTitik = 240, maksTitik = 384 } = {}) => {
  const { ukuran, gelap } = matriksQr(teks);
  const total = ukuran + MARGIN * 2;
  const skala = Math.max(3, Math.floor(Math.min(targetTitik, maksTitik) / total));
  const sisi = total * skala;
  const widthDots = Math.ceil(sisi / 8) * 8;
  const widthBytes = widthDots / 8;
  const heightDots = sisi;
  const bytes = new Uint8Array(widthBytes * heightDots);
  for (let y = 0; y < heightDots; y += 1) {
    const my = Math.floor(y / skala) - MARGIN;
    for (let x = 0; x < sisi; x += 1) {
      if (gelap(Math.floor(x / skala) - MARGIN, my)) bytes[y * widthBytes + (x >> 3)] |= 0x80 >> (x & 7);
    }
  }
  return { widthBytes, heightDots, bytes };
};
